import dayjs from "dayjs";

export const parseDateString = (isoString: string) => {
  return dayjs(isoString).toDate();
};
